/*
 * Android waiting list.
 *
 * The section is hidden in the markup and shown only here, so a visitor on an
 * iPhone never sees it appear and disappear. That direction matters: revealing
 * something is invisible when the test fails, whereas hiding something shows it
 * to everyone for the moment before the script runs.
 */

(function () {
  function isAndroid() {
    /* userAgentData is the modern answer but is Chromium-only and absent on
       plenty of Android browsers, so the user agent string is still the
       reliable test. Android is one of the few tokens that is unambiguous. */
    const data = navigator.userAgentData;
    if (data && Array.isArray(data.brands) && typeof data.platform === 'string') {
      if (data.platform === 'Android') return true;
    }
    return /android/i.test(navigator.userAgent || '');
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-wake-android]').forEach(function (section) {
      /* Also shown in the theme editor, where it would otherwise be invisible
         and impossible to edit, and after the form posts back, so somebody who
         signed up sees the confirmation even though the page reloaded. */
      const inEditor = window.Shopify && window.Shopify.designMode;
      if (isAndroid() || inEditor || section.querySelector('.wake-android__note--success')) {
        section.hidden = false;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
